export default __webpack_public_path__ + "static/media/logo.0093e32a.svg";